export const SET_DATA_REGISTER = 'set-data-register';
export const SET_EMAIL_FORGOT_PASS = 'set-email-forgot-pass';
export const SET_TOKEN_USER = 'set-token-user';
export const GET_LIST_CAMERA = 'get-list-camera';
export const RE_GET_NOTIFICATION = 're-get-notification';
export const GET_USER_NAME = 'get-user-name';
export const GET_LIST_CAMERA_PRIORITY = 'get-list-camera-priority';
export const REDIRECT_FOCUS = 'redirect-focus';
export const GET_LIST_WAREHOUSE = 'get-list-warehouse';
export const GET_VIEW_PORT = 'get-view-port';
export const GET_USER_TYPE = 'get-user-type';
export const GET_CAMERA_CODE = 'get-camera-code';
export const GET_LIST_CODE_CAMERA = 'get-list-code-camera';
export const GET_PATH_NOTIFICATION = 'get-path-video-notification';
export const SET_USER_PENDING_ACCEPT = 'set-user-pending-accept';
export const SEARCH_CAM_PLAYBACK =  'serach-cam-playback';
export const SET_FILTER_CAMERA =  'set-filter-camera';
export const SET_LIST_SERVICE =  'set-list-service';
export const GET_AVATAR_HEADER =  'get_avatar_header';
export const SET_SELECTED_AI_ALERT = 'set-selected-ai-alert';
